import { TooltipModule } from 'primeng/tooltip';
import { WorkbenchIntegratorService } from '../../../services/workbench-integrator.service';
import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { forkJoin, map } from 'rxjs';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Table } from 'primeng/table';
import { WatchService } from './watch.service'; // Assuming your WatchService handles API calls
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms'; // Required for ngModel

import { RefreshService } from '../../../services/refresh.service';
import { ConfigService } from '../../../services/config.service';
import { AjaxService } from '../../../services/ajax.service';
import { Pagination } from '../../../services/pagination.abstruct';
import { ViewScopeService } from '../../../services/view-scope.service';
import { TranslateService } from '../../../services/translate.service';
import { DirectionService } from '../../../services/direction.service';
import { EyeDialogComponent } from '../eye-dialog/eye-dialog.component';
import { DocApprovalComponent } from '../doc-approval/doc-approval.component';
import { AutoComplete } from 'primeng/autocomplete';


// PrimeNG Filter Modules
import { DropdownModule } from 'primeng/dropdown';
import { SelectItem } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { TabViewModule } from 'primeng/tabview';
import { DividerModule } from 'primeng/divider';
import { ChangeDetectorRef } from '@angular/core';
import { BadgeModule } from 'primeng/badge';

// Models (interfaces) that are in used.
import { MoveinRecord } from '../../../models/movein-record.model';
import { FileExpenseData } from '../../../models/file-expense-data.model';
import { FeatureComparison } from '../../../models/feature-comparison.model';

import { LastViewed } from '../../../services/workbench-integrator.service';

import { buildNotificationTag, NotificationDialogComponent, NotificationSummaryChange, NotificationTagInfo } from '../notification-dialog/notification-dialog.component';
import { NotificationDialogService } from '../notification-dialog/notification-dialog.service';

@Component({
	selector: 'app-watch',
	standalone: true,
	imports: [
		TooltipModule,
		CommonModule,
		TableModule,
		InputTextModule,
		ButtonModule,
		ProgressBarModule,
		TagModule,
		DialogModule,
		DropdownModule,
		CalendarModule,
		SliderModule,
		FormsModule,
		CheckboxModule,
		BadgeModule,
		InputNumberModule,
		TabViewModule,
		DividerModule,
		NotificationDialogComponent
	],
	templateUrl: './watch.component.html',
	styleUrls: ['./watch.component.scss'],
	providers: [CurrencyPipe, DatePipe, WatchService, DialogService]
})

export class WatchComponent extends Pagination implements OnInit {
	@Output() djwsChanged = new EventEmitter<number>(); // Emit FileRecID or array if needed
	private lastSelectionLength: number = 0;
	@Input() SpecificFileRecID: number = -1;

	@Input() parentComp?: DocApprovalComponent; // If this Watch component hosted inside a DocApprovalComponent this will store the father.


	ref?: DynamicDialogRef;
	// Stores only the invoices currently displayed in the UI (after sort/filter/search)
	displayedInvoices: any[] = [];

	// Track if any feature updates were made in this session
	private featuresWereUpdated = false;

	// Store original FeatureValueStd values for change detection
	private originalFeatureValueStd: { [id: number]: string | number | null } = {};

	invoices: any[] = [];
	@ViewChild('dt') dt!: Table;
	loading: boolean = true;
	errorMessage: string | null = null;



	displayNotificationsDialog: boolean = false;
	currentInvoiceIdForNotification: number | null = null;

	currentDocumentIndex: number = -1; // New: Track the current document index in the invoices array

	// Properties for Feature Comparison Tab
	featureComparisonData: FeatureComparison[] = [];
	isFeatureDataLoading: boolean = false;

	mtOptions: SelectItem[] = [
		{ label: 'תנועת חשבונית', value: '0' },
		{ label: 'תנועת קבלה', value: '1' }
	];

	statuses: SelectItem[] = [];
	selectedCustomerFilterValues: string[] = [];
	hasActiveTableFilters: boolean = false;

	hideEmptyColumnsEnabled: boolean = false;
	columnVisibility: { [key: string]: boolean } = {};
	allColumnFields: string[] = [
		'ID', 'MT', 'CodeSugTnua', 'Asmakhta_Rishona', 'Asmakhta_Shiya', 'Taarikh_Asmakhta',
		'Taarikh_Erekh', 'Code_Tamkhir', 'Code_Matbea', 'Pratim',
		'Kheshbon_Khova_1', 'Kheshbon_Khova_1_name', 'Kheshbon_Khova_2', 'Kheshbon_Khova_2_name', 'Kheshbon_Zkhut_1', 'Kheshbon_Zkhut_1_name', 'Kheshbon_Zkhut_2',
		'Skhum_khova_1_shek', 'Skhum_khova_2_shek', 'Skhum_Zkhut_1_shek', 'Skhum_Zkhut_2_shek',
		'Skhum_khova_1_matbea_khutz', 'Skhum_khova_2_matbea_khutz', 'Skhum_Zkhuta_1_matbea_khutz',
		'Skhum_Zkhuta_2_matbea_khutz', 'Taarikh_3', 'Asmakhta_3', 'Kamut', 'Kovetz',
		'Hearot_Nosafot', 'Hearot_Nosafot_2', 'Snif', 'Mispar_Osek_Murshe', 'CustomerName', 'Asmakhta_4',
		'Asmakhta_5', 'Taarikh_4', 'Taarikh_5', 'Mispar_Haktzaa', 'FileRecID', 'OriginalFileName',
		//'FileName', 'URL', 'MoveIn'
	];

	private dateFeatures: string[] = [
		'payment_maturity_date',
		'payment_date',
		'doc_publish_date'
	];

	public paymentFeatures: string[] = [
		'total_without_tax',
		'total_discount',
		'total_after_discount',
		'tax',
		'vat_in_precentages',
		'total_with_tax',
		'total'
	];

	public editingPaymentFeature: string | null = null;

	// Data we use for the ThirdTab - Calculated Data
	public rawExpenseData: FileExpenseData | null = null;
	isCalculatedDataEditing: boolean = false;
	// Add displayString property for autocomplete
	expenseLotOptions: (FileExpenseData & { displayString: string })[] = [];
	filteredExpenseLotOptions: (FileExpenseData & { displayString: string })[] = [];

	columnHeadersMap: { [key: string]: string } = {};

	selectedInvoices: any[] = [];
	activeTab: number = 0;
	direction: 'ltr' | 'rtl' = 'rtl';


	constructor(
		private watchService: WatchService,
		private sanitizer: DomSanitizer,
		private datePipe: DatePipe,
		private currencyPipe: CurrencyPipe,
		public translateServ: TranslateService,
		public directionServ: DirectionService,
		private refreshService: RefreshService,
		private ajaxService: AjaxService,
		private configService: ConfigService,
		private viewScopeService: ViewScopeService,
		private dialogService: DialogService,
		private notificationDialogService: NotificationDialogService,
		public workbenchIntegrator: WorkbenchIntegratorService,
		private cdr: ChangeDetectorRef
	) {
		super();
	}

	ngOnInit(): void 
	{
		this.initializeColumnHeadersMap();
		this.loadInvoices();
		this.direction = this.directionServ.isRtl() ? 'rtl' : 'ltr';

		// Restore last viewed journal selection if available
		const lastViewed = this.workbenchIntegrator.getLastViewed();
		if (lastViewed && typeof lastViewed.journalId === 'number') {
			setTimeout(() => {
				// Find the index of the last viewed journal in the invoices array
				const index = this.invoices.findIndex(i => i.ID === lastViewed.journalId);
				if (index !== -1 && this.dt) {
					// Calculate the page number (PrimeNG Table is 0-based)
					const rowsPerPage = this.dt.rows || 10;
					const page = Math.floor(index / rowsPerPage);
					// Store for go-back action
					(this as any)._lastViewedIndex = index;
					(this as any)._lastViewedPage = page;
					// Optionally, scroll to the row if table supports it
					// this.dt.first = page * rowsPerPage; // Uncomment if you want to auto-navigate
				}
			}, 500);
		}
	}

	/**
	 * Ensures that for each documentId, all journalIds exist in the workbench integrator for the current user.
	 * @param documentIds Array of document IDs
	 * @param journalIds Array of journal IDs
	 */

	// ??? Is this even in use?
	ensureJournalsInWorkbench(documentIds: number[], journalIds: number[]): void {
		if (!documentIds || !journalIds) return;
	
		documentIds.forEach(docId => {
			this.workbenchIntegrator.ensureDocumentAndJournalsExist(docId, journalIds);
		});
	}

	private initializeColumnHeadersMap(): void {
		console.log('--- Initializing Column Headers Map ---');
		console.log('TranslateService Dictionary (full content):', this.translateServ.dictionary);

		const fieldToDictKeyMap: { [key: string]: string } = {
			'ID': 'JMT_COL_ID',
			'MT': 'JMT_COL_MOVE_TYPE',
			'CodeSugTnua': 'JMT_COL_CODE_MOVE_TYPE',
			'Asmakhta_Rishona': 'JMT_COL_FIRST_REF',
			'Asmakhta_Shiya': 'JMT_COL_SECOND_REF',
			'Taarikh_Asmakhta': 'JMT_COL_DATE_REF',
			'Taarikh_Erekh': 'JMT_COL_VAL_DATE',
			'Code_Tamkhir': 'JMT_COL_PRICING_CODE',
			'Code_Matbea': 'JMT_COL_COIN_CODE',
			'Pratim': 'JMT_COL_DETAILS',
			'Kheshbon_Khova_1': 'JMT_COL_HOVA_1_ACCOUNT',
			'Kheshbon_Khova_2': 'JMT_COL_HOVA_2_ACCOUNT',
			'Kheshbon_Zkhut_1': 'JMT_COL_ZHUT_1_ACCOUNT',
			'Kheshbon_Zkhut_2': 'JMT_COL_ZHUT_2_ACCOUNT',
			'Skhum_khova_1_shek': 'JMT_COL_AMOUNT_HOVA_1_NIS',
			'Skhum_khova_2_shek': 'JMT_COL_AMOUNT_HOVA_2_NIS',
			'Skhum_Zkhut_1_shek': 'JMT_COL_AMOUNT_ZHUT_1_NIS',
			'Skhum_Zkhut_2_shek': 'JMT_COL_AMOUNT_ZHUT_2_NIS',
			'Skhum_khova_1_matbea_khutz': 'JMT_COL_AMOUNT_HOVA_1_NO_NIS',
			'Skhum_khova_2_matbea_khutz': 'JMT_COL_AMOUNT_HOVA_2_NO_NIS',
			'Skhum_Zkhuta_1_matbea_khutz': 'JMT_COL_AMOUNT_ZHUT_1_NO_NIS',
			'Skhum_Zkhuta_2_matbea_khutz': 'JMT_COL_AMOUNT_ZHUT_2_NO_NIS',
			'Taarikh_3': 'JMT_COL_DATE_3',
			'Asmakhta_3': 'JMT_COL_REF_3',
			'Kamut': 'JMT_COL_AMOUNT',
			'Kovetz': 'JMT_COL_DOC',
			'Hearot_Nosafot': 'JMT_COL_ADDITIONAL_COMMENTS',
			'Hearot_Nosafot_2': 'JMT_COL_ADDITIONAL_COMMENTS_2',
			'Snif': 'JMT_COL_BRANCH',
			'Mispar_Osek_Murshe': 'JMT_COL_BUSINESS_ID',
			'Asmakhta_4': 'JMT_COL_REF_4',
			'Asmakhta_5': 'JMT_COL_REF_5',
			'Taarikh_4': 'JMT_COL_DATE_4',
			'Taarikh_5': 'JMT_COL_DATE_5',
			'Mispar_Haktzaa': 'JMT_COL_ALLOC_NUMBER',
			'OriginalFileName': 'JMT_COL_ORIG_FILE_NAME',
			'FileName': 'JMT_COL_WATCH_N_EDIT',
			'FileRecID': 'doc_num',
			'URL': 'JMT_DOWNLOAD_JOURNAL_MOVE',
			'MoveIn': 'JMT_VAL_REC_MOVE',
			'Kheshbon_Khova_1_name': 'JMT_COL_HOVA_1_NAME',
			'Kheshbon_Zkhut_1_name': 'JMT_COL_ZHUT_1_ACCOUNT_NAME',
			'Kheshbon_Khova_2_name': 'JMT_COL_HOVA_2_NAME',
			'CustomerName': 'JMT_COL_CUST_NAME'
		};


		this.allColumnFields.forEach(field => {
			const dictKey = fieldToDictKeyMap[field];
			if (dictKey) {
				const translation = this.translateServ.dictionary[dictKey];
				if (translation) {
					this.columnHeadersMap[field] = translation;
					console.log(`Header Mapped: Field '${field}' -> Dict Key '${dictKey}' -> Translation: '${translation}'`);
				} else {
					this.columnHeadersMap[field] = field;
					console.warn(`Translation MISSING for field '${field}' (Dict Key: '${dictKey}'). Falling back to field name.`);
				}
			} else {
				this.columnHeadersMap[field] = field;
				console.warn(`Dictionary Key Mapping MISSING for field '${field}'. Falling back to field name.`);
			}
		});

		console.log('Final Column Headers Map after initialization:', this.columnHeadersMap);

	}

	// Call this method from (onSort), (onFilter), (onValueChange), etc. in the table to keep displayedInvoices in sync
	onTableSortOrFilter(event: any): void {
		// Always update displayedInvoices to match the visible rows in the table
		if (this.dt) {
			this.displayedInvoices = this.dt.filteredValue || this.dt.value || [];
		} else {
			this.displayedInvoices = this.invoices;
		}
		// Reset currentDocumentIndex to the first visible document
		this.currentDocumentIndex = this.displayedInvoices.length > 0 ? 0 : -1;
		this.hasActiveTableFilters = this.hasTableFilters(event?.filters);
	}

	private hasTableFilters(filters: any): boolean {
		if (!filters) return false;

		return Object.values(filters).some((filter: any) => {
			const values = Array.isArray(filter) ? filter : filter?.constraints || [filter];
			return values.some((constraint: any) => {
				const value = constraint?.value ?? constraint;
				return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== '';
			});
		});
	}

	initializeColumnVisibility(): void {
		this.allColumnFields.forEach(field => {
			this.columnVisibility[field] = true;
		});
	}

	detectEmptyColumns(): void {
		if (!this.invoices || this.invoices.length === 0) {
			this.allColumnFields.forEach(field => {
				this.columnVisibility[field] = true;
			});
			return;
		}

		const emptyColumns: { [key: string]: boolean } = {};
		this.allColumnFields.forEach(field => {
			emptyColumns[field] = true;
		});

		this.invoices.forEach(invoice => {
			this.allColumnFields.forEach(field => {
				const value = (invoice as any)[field];
				if (value !== null && value !== undefined && value !== '' &&
					!(Array.isArray(value) && value.length === 0) &&
					!(typeof value === 'object' && Object.keys(value).length === 0 && value.constructor === Object)) {
					emptyColumns[field] = false;
				}
			});
		});

		this.allColumnFields.forEach(field => {
			this.columnVisibility[field] = !this.hideEmptyColumnsEnabled || !emptyColumns[field];
		});

		console.log('Detected empty columns:', Object.keys(emptyColumns).filter(key => emptyColumns[key]));
		console.log('Current column visibility:', this.columnVisibility);
	}

	toggleHideEmptyColumns(): void {
		this.hideEmptyColumnsEnabled = !this.hideEmptyColumnsEnabled;
		this.detectEmptyColumns();
	}

	clearAllFilters(globalSearchInput?: HTMLInputElement): void {
		if (this.dt) {
			this.dt.clear();
			if (this.dt.clearState) {
				this.dt.clearState();
			}
			this.selectedCustomerFilterValues = [];
		}

		if (globalSearchInput) {
			globalSearchInput.value = '';
		}

		this.displayedInvoices = [...this.invoices];
		this.currentDocumentIndex = this.displayedInvoices.length > 0 ? 0 : -1;
		this.hasActiveTableFilters = false;
	}

	onRowDoubleClick(event: any): void {
		const invoice = event?.data;
		console.log('Double-clicked invoice:', invoice);
		if (invoice?.URL) {
			this.openPreview(invoice);
		} else {
			console.warn('No URL found on invoice:', invoice);
		}
	}

	openPreview(invoice: MoveinRecord): void {
		console.log('Opening preview for invoice:', invoice);
		// Mark as last viewed journal
		this.workbenchIntegrator.setLastViewed(invoice.FileRecID, invoice.ID);
		// Prepare data to pass to EyeDialogComponent
		const data = {
			invoice,
			displayedInvoices: this.displayedInvoices,
			currentDocumentIndex: this.displayedInvoices.findIndex(inv => inv.ID === invoice.ID),
			direction: this.direction,
			columnHeadersMap: this.columnHeadersMap,
			parentComp: this,
			isEditAllowed: this.parentComp ? this.parentComp.getClassMode() === 0 : true, // If it parent of doc-approval - check what class mode it is, otherwise, it is an original call and allow to edit.
		};
		this.ref = this.dialogService.open(EyeDialogComponent, {
			header: this.translateServ.dictionary['JOURNAL_MOVES_PREVIEW_TITLE'] || 'Preview',
			width: '70vw',
			height: '80vw',
			data,
			modal: true,
			dismissableMask: true,
			draggable: true,        // Allow moving the dialog
			closable: true,        // Show close button in header
			maximizable: true,     // Show maximize button in header
			minimizable: true,     // Show minimize button in header (if supported by your PrimeNG version)
			imports: [
				CommonModule,
				DialogModule,
				TabViewModule,
				TableModule,
				TagModule,
				TooltipModule,
				AutoComplete,
				ButtonModule,
				ProgressBarModule,
				FormsModule,
				EyeDialogComponent
			]
		} as any);
		this.ref.onClose.subscribe(() => 
		{
			// Check the service instead of the emitted 'changesMade' variable
			if (this.watchService.dialogChangesMade) {
				this.loadInvoices();
				this.watchService.dialogChangesMade = false; // IMPORTANT: Reset the flag for the next time the dialog opens
				if(this.parentComp) this.parentComp.reloadData();
			}
		});
	}

	private refreshPage() 
	{
		this.refreshService.triggerPageRefresh();
	}


	public getPreviewDisplayValue(field: string, value: any): string {
		if (value === null || value === undefined || value === '') {
			return '';
		}

		if (field === 'ID') {
			return String(value);
		}

		if (field === 'MT') {
			return this.getMtDisplayText(value);
		}

		if (field.startsWith('Taarikh_') && typeof value === 'string') {
			const date = new Date(value);
			if (!isNaN(date.getTime())) {
				return this.datePipe.transform(date, 'dd/MM/yyyy') || value;
			}
			return value;
		}
		if (field.startsWith('Taarikh_') && value instanceof Date) {
			return this.datePipe.transform(value, 'dd/MM/yyyy') || String(value);
		}

		if (field.includes('Skhum_') && (field.includes('_shek') || field.includes('_matbea_khutz'))) {
			try {
				const numValue = parseFloat(value);
				if (isNaN(numValue)) return value;

				const currencyCode = field.includes('_shek') ? 'ILS' : 'USD';
				return this.currencyPipe.transform(numValue, currencyCode, 'symbol', '1.2-2') || value;
			} catch (e) {
				console.warn(`Failed to format currency for field ${field}:`, value, e);
				return value;
			}
		}

		return String(value);
	}

	getMtDisplayText(mtValue: string | number | null): string {
		const valueAsString = String(mtValue).trim();
		if (valueAsString === '0') {
			return this.translateServ.dictionary['JMT_VAL_INV_MOVE'];
		} else if (valueAsString === '1') {
			return this.translateServ.dictionary['JMT_VAL_REC_MOVE'];
		}
		return '';
	}

	getMtSeverity(mtValue: string | number | null): string {
		const valueAsString = String(mtValue).trim();
		if (valueAsString === '0') {
			return 'info';
		} else if (valueAsString === '1') {
			return 'success';
		}
		return 'secondary';
	}

	getColumnHeader(field: string): string {
		return this.columnHeadersMap[field] || field;
	}

	toggleHideEmptyColumnsInPreview(): void {
		this.hideEmptyColumnsEnabled = !this.hideEmptyColumnsEnabled;
	}


	isSelected(invoice: any): boolean {
		return this.selectedInvoices.some(selected => selected.ID === invoice.ID);
	}

	reloadData()
	{
		this.loadInvoices();
		setTimeout(() => { this.cdr.detectChanges(); }, 0);
	}

	loadInvoices(): void
	{
		
		this.loading = true;
		console.log('Loading invoices... loading flag set to true.'); // Log loading state
		this.initializeColumnVisibility();	
		
		
		this.errorMessage = null;

		this.watchService.getInvoices(
			this.viewScopeService.getCurrentCustomer(),
			this.viewScopeService.getCurrentOpertaingUserId().toString(),
			this.SpecificFileRecID
		).subscribe(
		{
			next: (data: any[]) => {
				console.log('Raw data received:', data);
				this.invoices = data;
				this.displayedInvoices = [...data];
				this.applyUnresolvedNotificationSummaries(this.invoices);
				this.loading = false;
				console.log('Invoices loaded successfully. loading flag set to false.'); // Log loading state


				
					// Ensure all journals for all documents are present in localStorage
					const docToJournals: { [docId: number]: Set<number> } = {};
					data.forEach(inv => {
						const docId = inv.FileRecID;
						const journalId = inv.ID;
						if (docId == null || journalId == null) return;
						if (!docToJournals[docId]) docToJournals[docId] = new Set();
						docToJournals[docId].add(journalId);
					});
					Object.entries(docToJournals).forEach(([docId, journalSet]) => {
						this.workbenchIntegrator.ensureDocumentAndJournalsExist(Number(docId), Array.from(journalSet));
					});

					// Sync selectedInvoices with checked journals in integrator
					this.selectedInvoices = this.invoices.filter(inv =>
						this.workbenchIntegrator.isJournalChecked(inv.FileRecID, inv.ID)
					);

					setTimeout(() => {
						if (this.invoices && this.invoices.length > 0) {
							// Already synced above
						} else {
							this.selectedInvoices = [];
							console.log('No invoices to select.');
						}
					}, 0);

				

				
				this.detectEmptyColumns();
				this.hideEmptyColumnsEnabled = false;
				this.toggleHideEmptyColumns();
			},
			error: (err) => {
				console.error('Error fetching data:', err);
				this.errorMessage = this.translateServ.dictionary['FAILED_LOAD_DATA'];
				this.loading = false;
				console.error('Error loading invoices. loading flag set to false.'); // Log loading state
			}
		});
	}
	getNotificationTag(invoice: { NotifCount?: number | string | null; NotifColor?: string | null }): NotificationTagInfo {
		return buildNotificationTag(invoice);
	}

	private applyUnresolvedNotificationSummaries(rows: any[]): void {
		const fileRecIds = [...new Set(rows.map(row => row.FileRecID).filter((fileRecId): fileRecId is number => typeof fileRecId === 'number'))];
		if (fileRecIds.length === 0) return;

		forkJoin(fileRecIds.map(fileRecId =>
			this.notificationDialogService.getFileNotifications(fileRecId).pipe(
				map(notifications => ({ fileRecId, tag: buildNotificationTag(notifications) }))
			)
		)).subscribe(summaries => {
			summaries.forEach(summary => {
				const count = Number(summary.tag.value) || 0;
				this.onNotificationSummaryChange({
					fileRecId: summary.fileRecId,
					NotifCount: count,
					NotifColor: count > 0 ? summary.tag.severity : null,
					tag: summary.tag
				});
			});
		});
	}

	openNotificationsDialog(invoice: any): void {
		this.currentInvoiceIdForNotification = invoice.FileRecID;
		this.displayNotificationsDialog = true;
	}

	onNotificationSummaryChange(summary: NotificationSummaryChange): void {
		this.applyNotificationSummaryChange(summary);
		this.parentComp?.onNotificationSummaryChange(summary);
	}

	public applyNotificationSummaryChange(summary: NotificationSummaryChange): void {
		this.invoices
			.filter(invoice => invoice.FileRecID === summary.fileRecId)
			.forEach(invoice => {
				invoice.NotifCount = summary.NotifCount;
				invoice.NotifColor = summary.NotifColor;
			});

		setTimeout(() => { this.cdr.detectChanges(); }, 0);
	}


	exportMovein(): void {
		if (!this.selectedInvoices?.length) return;

		const recIds = this.selectedInvoices.map(inv => inv.ID);

		this.watchService.exportMovein(recIds).subscribe({
			next: (res) => {
				console.log("Export success: ", res);

				this.openExportedFile(res?.StatusDescription);
				this.refreshPage();

				// Remove exported journals from workbenchIntegrator
				this.selectedInvoices.forEach(inv => {
					this.workbenchIntegrator.ensureDocumentAndJournalsExist(inv.FileRecID, [inv.ID], 'delete');
				});
			},
			error: (err) => {
				console.error("Export failed:", err);
			}
		});
	}

	// Guards against opening server-side file paths (e.g. "D:\..." or "\\server\share\...") as file:// links, which browsers block as a cross-origin security violation.
	private openExportedFile(url: string | undefined | null): void {
		if (!url) {
			console.error("No StatusDescription in response");
			return;
		}
		if (!/^https?:\/\//i.test(url)) {
			console.error("StatusDescription is not a valid URL, refusing to open:", url);
			return;
		}
		window.open(url, '_blank');
	}


	/**
	 * Called when DJWS changes from a child or dialog (e.g., EyeDialogComponent)
	 * Optionally accepts changedFileRecID to refresh only the affected invoice.
	 */
	onDJWSChanged(isParentRequest : boolean, changedFileRecID?: number, changedJournalRecID?: number): void 
	{
		// Sync selectedInvoices with checked journals in integrator
		this.selectedInvoices = this.invoices.filter(inv => this.workbenchIntegrator.isJournalChecked(inv.FileRecID, inv.ID));

		if(!isParentRequest && this.parentComp) this.parentComp.onDJWSChanged(isParentRequest, changedFileRecID,changedJournalRecID);
				
		setTimeout(() => { this.cdr.detectChanges(); }, 0); // Refresh UI if needed
	}

	onJournalCheckboxChanged(event: any, checked: boolean): void {
		const journalId = event.data?.ID;
		this.workbenchIntegrator.changeStatus(false, journalId, checked);
		// Optionally emit FileRecID if available
		
		if (event.data?.FileRecID) 
		{
			this.djwsChanged.emit(event.data.FileRecID);
			this.onDJWSChanged(false, event.data.FileRecID, event.data.ID);
		}
		else 
		{
			this.djwsChanged.emit();
			this.onDJWSChanged(false);
		}
	}

	onAllJournalCheckboxChanged(selected: any[]): void {
		const allSelected = selected && selected.length === this.invoices.length;
		const noneSelected = !selected || selected.length === 0;
		const checked = allSelected;
		if (allSelected || noneSelected) {
			this.invoices.forEach(inv => {
				const isChecked = this.workbenchIntegrator.isJournalChecked(inv.FileRecID, inv.ID);
				if (isChecked !== checked) {
					this.onJournalCheckboxChanged({ data: inv }, checked);
				}
			});
		}
		this.lastSelectionLength = selected ? selected.length : 0;
		
		this.djwsChanged.emit(this.invoices[0]?.FileRecID); // Optionally emit the first FileRecID or undefined
	}

	// Returns true if the row is the last viewed journal (for row highlight)
	isLastViewed(invoice: any): boolean {
		const lastViewed = this.workbenchIntegrator.getLastViewed() as LastViewed;
		return lastViewed && typeof lastViewed.journalId === 'number' && invoice.ID === lastViewed.journalId;
	}

	/**
	 * Scrolls the table to the last viewed journal and highlights/selects it.
	 */
	goToLastViewed(): void {
		if (!this.dt) return;
		const lastViewed = this.workbenchIntegrator.getLastViewed();
		if (!lastViewed || typeof lastViewed.journalId !== 'number') return;

		// Find the index of the last viewed journal in the current invoices
		const index = this.invoices.findIndex(i => i.ID === lastViewed.journalId);
		if (index === -1) return;

		// Calculate the page number (PrimeNG Table is 0-based)
		const rowsPerPage = this.dt.rows || 10;
		const page = Math.floor(index / rowsPerPage);
		this.dt.first = page * rowsPerPage;

		setTimeout(() => {
			// const lastViewedInvoice = this.invoices[index];
			// if (lastViewedInvoice && !this.selectedInvoices.some(inv => inv.ID === lastViewedInvoice.ID)) {
			// 	this.selectedInvoices = [lastViewedInvoice];
			// }
			// Try to scroll to the row in the DOM (if needed)
			const rowElem = document.querySelector(`#watch-journal-table tr[ng-reflect-ng-class*='lastly-viewed-row']`);
			if (rowElem && typeof (rowElem as any).scrollIntoView === 'function') {
				(rowElem as any).scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		}, 200);
	}
}